import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { useTable, useSortBy } from 'react-table';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import usePaginatedTable from '../../../hooks/UsePaginatedTable';
import PaginationSection from '../../../components/pagination/PaginationSection';

function VehiclesTable({
  vehicles,
  onDeleteVehicle,
  batchSelectedVehicles,
  setBatchSelectedVehicles,
  rowsPerPage,
}) {
  // Pagination
  const [page, setPage] = useState(1);
  const { slice, range } = usePaginatedTable(vehicles, page, rowsPerPage);

  const data = useMemo(() => slice, [slice]);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        id: 'cb-column',
        accessor: 'vehicleId',
        Header: () => (
          <>
            <input
              type='checkbox'
              checked={vehicles.length === batchSelectedVehicles.length}
              onChange={(e) => {
                if (e.target.checked) {
                  let newArray = [...batchSelectedVehicles];

                  let elementsToAdd = slice.filter(
                    (el) =>
                      !newArray.some((_el) => _el.vehicleId === el.vehicleId)
                  );

                  newArray = [...newArray, ...elementsToAdd];

                  setBatchSelectedVehicles(newArray);
                } else {
                  let newArray = [...batchSelectedVehicles];
                  newArray = newArray.filter(
                    (el) => !slice.some((_el) => _el.vehicleId === el.vehicleId)
                  );
                  setBatchSelectedVehicles(newArray);
                }
              }}
            />
          </>
        ),
        className: 'p-3 ps-2',
        style: { width: '100px' },
        Cell: (props) => (
          <>
            <input
              type='checkbox'
              checked={batchSelectedVehicles.some(
                (v) => v.vehicleId === props.row.original.vehicleId
              )}
              onChange={() => {
                const vehicleId = props.row.original.vehicleId;
                let newArr = [...batchSelectedVehicles];

                if (newArr.some((v) => v.vehicleId === vehicleId)) {
                  newArr = newArr.filter((v) => v.vehicleId !== vehicleId);
                } else {
                  newArr = [...newArr, props.row.original];
                }

                setBatchSelectedVehicles(newArr);
              }}
            />
          </>
        ),
        disableSortBy: true,
      },
      {
        Header: 'Tävlingsnummer',
        accessor: 'racingNumbers', // accessor is the "key" in the data
        className: 'p-3',
        style: { width: '40%' },
        Cell: ({ cell: { value } }) => (
          <div className='d-flex gap-1'>
            {value?.map((rn, index) => (
              <span key={index} className='bg-secondary-black text-white p-1'>
                {rn}
              </span>
            ))}
          </div>
        ),
      },
      {
        Header: 'Besiktning',
        accessor: 'translatedInspectionStatus',
        className: 'p-3',
        Cell: ({ cell: { value } }) => (
          <div className='d-flex'>
            {value === 'Godkänd' ? (
              <span className='bg-success p-1'>{value}</span>
            ) : (
              <span>{value}</span>
            )}
          </div>
        ),
      },
      {
        Header: '',
        accessor: 'vehicleId',
        className: 'p-3 d-flex justify-content-end',
        Cell: ({ cell: { value } }) => (
          <Button
            variant='outline-primary'
            className='d-flex align-items-center justify-conent-between'
            onClick={() => onDeleteVehicle(value)}
          >
            <span className='material-symbols-outlined'>delete</span>
            Ta bort
          </Button>
        ),
      },
    ],
    [
      batchSelectedVehicles,
      setBatchSelectedVehicles,
      onDeleteVehicle,
      slice,
      vehicles.length,
    ]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  return (
    <div className='d-flex flex-column w-100'>
      <Table
        {...getTableProps()}
        style={{
          borderCollapse: 'separate',
          borderSpacing: '0 0.5rem',
          width: '100%',
        }}
        className='table-borderless'
        hover
      >
        <thead className='bg-divider'>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className='bg-white'
                style={{ borderStyle: 'none' }}
                role='button'
                onClick={() => {
                  const competitionId = row?.original?.id;

                  if (competitionId) {
                    navigate(`./${competitionId}/details`);
                  }
                }}
              >
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      className={cell.column.className}
                      style={cell.column.style}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <PaginationSection
        range={range}
        slice={slice}
        setPage={setPage}
        page={page}
      />
    </div>
  );
}

export default VehiclesTable;
